import NotesIcon from '@mui/icons-material/Notes';

const DefaultStyle = {
  id: 'default',
  name: 'Default',
  description: 'Clean look, no extra icons or borders.',
  icon: <NotesIcon />,
  settings: {
    useSectionIcons: false,
    useContactIcons: false,
    showSectionTitleBorder: false,
    sectionTitleBorderWidth: '0px',
  },
};

export default DefaultStyle; 